<template>
    <div>
        <h3 class="title is-3 has-text-centered">{{ heading }}
            <span v-if="teamId"><br><br>Team goal completion {{ $filters.currency(totalPrice) }} / {{ $filters.currency(teamMonthlyGoal) }} ({{teamMonthlyGoalPercent}}%)</span>
        </h3>

        <div class="columns is-multiline">
            <div class="column">
                <o-table class="is-responsive is-responsive-xs-desktop"
                         v-if="isTableVisible"
                         :data="processedData"

                         :bordered="table.bordered"
                         :striped="table.striped"
                         :narrowed="table.narrowed"
                         :checkable="false"
                         :mobile-cards="table.mobileCards"
                         :paginated="table.paginated"
                         :pagination-simple="table.paginationSimple"
                         :per-page="table.perPage"
                         default-sort-direction="asc"
                         default-sort="name"
                >
                    <template>
                        <o-table-column #default="{ row }" field="name" label="Name" sortable>
                            {{ row.name }}
                        </o-table-column>
                        <o-table-column #default="{ row }" field="reimbursable" label="Reimbursable" sortable>
                            {{ $filters.yesNo(row.reimbursable) }}
                        </o-table-column>
                        <o-table-column #default="{ row }" field="qty" label="QTY" sortable>
                            <div @click="showUserBilling(row.user_id, row.reimbursable)">
                                <a @click.prevent>{{ row.qty }}</a>
                            </div>
                        </o-table-column>
                        <o-table-column #default="{ row }" field="price" label="Amount" sortable>
                            {{ $filters.currency(row.price) }}
                        </o-table-column>
                        <o-table-column #default="{ row }" field="monthly_goal_percent" label="Goal" sortable>
                            <span v-if="!row.reimbursable">
                                {{ $filters.currency(row.price) }} / {{ $filters.currency(row.monthly_goal) }} ({{ row.monthly_goal_percent }}%)
                            </span>
                            <span v-else>–</span>
                        </o-table-column>
                    </template>
                    <template #footer v-if="processedData.length > 0">
                      <th colspan="2">Total</th>
                      <th class="value">{{ totalQuantity }}</th>
                      <th class="value">{{ $filters.valueOrDefault($filters.currency(totalPrice), '-') }}</th>
                      <th></th>
                    </template>
                  <template #empty>
                    <div class="has-text-centered">
                      This table is empty!
                    </div>
                  </template>
                </o-table>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import Table from './../../../../mixins/Table'

    export default {
        mixins: [Table],

        props: ['heading', 'data', 'teamId'],

        computed: {
            ...mapGetters(['userNameById', 'userById', 'teamById', 'isBillingReimbVisible']),

            processedData() {
                let isReimbVisible = this.isBillingReimbVisible

                if (!_.isArray(this.data)) {
                    return []
                }

                let data = _.values(_.reduce(this.data, (res, row) => {
                    let userId = row.user_id
                    if (res[userId] === undefined) {
                        res[userId] = {
                            user_id: userId, name: this.userNameById(userId),
                            qty: 0, price: 0, qty_r: 0, price_r: 0
                        }
                    }
                    res[userId].qty += parseInt(row.qty_billed)
                    res[userId].price += parseInt(row.price_billed)
                    res[userId].qty_r += parseInt(row.qty_reimb)
                    res[userId].price_r += parseInt(row.price_reimb)

                    return res
                }, {}))

                return _.reduce(data, (res, row) => {
                    let monthlyGoal = this.userById(row.user_id).monthly_goal,
                        monthlyPercent = (monthlyGoal ? ((row.price / monthlyGoal) * 100) : 0).toFixed(2)

                    res.push({user_id: row.user_id, name: this.userNameById(row.user_id), price: row.price, qty: row.qty, monthly_goal: monthlyGoal, monthly_goal_percent: monthlyPercent, reimbursable: false})

                    if (isReimbVisible) {
                        res.push({user_id: row.user_id, name: this.userNameById(row.user_id), price: row.price_r, qty: row.qty_r, monthly_goal: '–', monthly_goal_percent: '–', reimbursable: true})
                    }

                    return res
                }, [])
            },

            totalPrice() {
                return _.sumBy(this.processedData, 'price')
            },

            totalQuantity() {
                return _.sumBy(this.processedData, 'qty')
            },

            teamMonthlyGoalPercent() {
                return this.teamMonthlyGoal ? ((this.totalPrice / this.teamMonthlyGoal) * 100).toFixed(2) : 0
            },

            teamMonthlyGoal() {
                return this.teamId ? this.teamById(this.teamId).monthly_goal : 0
            }
        },

        methods: {
            showUserBilling(userId, reimbursable) {
                this.$emit('row-clicked', null, userId, reimbursable)
            }
        }
    }
</script>